import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Apollo} from "apollo-angular";
import {get_credit_outlets_list} from "./graphql/getFunds";
import {MatTableDataSource} from "@angular/material/table";
import {DatePipe} from "@angular/common";
import {DataFormatService} from "../services/data-format.service";
import { MatDialog } from "@angular/material/dialog";
import { AddFundComponent } from "./add-fund/add-fund.component";
import { AddCertificatedOutletComponent } from "./add-certificated-outlet/add-certificated-outlet.component";
import { Subscription } from "rxjs";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import FundBtnType from "../enums/fund-button-type";


export interface FundsListTable {
  name: string,
  type: string,
  accMgr: string,
  srSyndications: string,
  syndications: string,
  totalCommitted: number,
  totalSpecified: number,
  closeDate: any
}
@Component({
    selector: 'app-funds',
    templateUrl: './funds-list.component.html',
    styleUrls: ['./funds-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundsListComponent implements OnInit{
  public dataSource: MatTableDataSource<FundsListTable>
  public columns: string[] = ['name', 'type', 'srSyndications', 'syndications', 'accMgr', 'closeDate', 'totalCommitted', 'totalSpecified']
  public total = 0;
  public perPage = 50;
  public currentPage = 0;
  public permissions:any = null
  public pages: PageEvent[] = []
  public pageLength = 0
  public funds:any = []

  constructor(private apollo: Apollo, private datePipe: DatePipe, public dataFormat: DataFormatService,  private dialog: MatDialog) {}
  @ViewChild(MatSort) sort: MatSort
  @ViewChild(MatPaginator) paginator: MatPaginator
  ngOnInit() {
    this.getFunds(null)
  }

  pageSort(event:Sort){
    this.dataSource.data = this.funds
    if(this.dataSource.sort){
      this.dataSource.sort.active = event.active
      this.dataSource.sort.direction = event.direction
      this.dataSource._updateChangeSubscription()
    }
  }


  getFunds(page:number | null){
    let querySubscription = this.apollo.watchQuery({
      query: get_credit_outlets_list,
      variables: {
        page: page
      }
    }).valueChanges.subscribe(({data}:any) => {
      this.permissions = data.me.fundPermissions;
      let funds:any = []
      let collectiveFunds:any[] = [...data.getFunds, ...data.certificatedOutlets]
      collectiveFunds.forEach((fund:any) => {
        let tableData = {
          id: fund.id,
          name: fund.__typename == 'Fund' ? fund.name : fund.organization?.name,
          type: fund.__typename == 'Fund' ? fund.fundType.name : 'Certificated',
          srSyndications: this._getFundParticipantsByRole(fund.participants ?? [], 'Senior Syndications Analyst'),
          syndications: this._getFundParticipantsByRole(fund.participants ?? [], 'Syndications Analyst'),
          accMgr: this._getFundParticipantsByRole(fund.participants ?? [], 'Syndications Account Manager'),
          closeDate: fund.close_date,
          totalCommitted: fund.invested_equity,
          totalSpecified: fund.specified_equity,
          __typename: fund.__typename
        }
        funds.push(tableData)
      })
      this.funds = this._sortAndMergeCertificatedOutlets(funds)
      this.dataSource = new MatTableDataSource<FundsListTable>(this.funds)
      this.dataSource.paginator = this.paginator
      this.dataSource.sort = this.sort
      this.dataSource._updateChangeSubscription()
      this.total = this.dataSource.data.length;
      this.createPages(this.dataSource.data)
    })
  }

  _getFundParticipantsByRole(participants:any[], role:string) {
    return participants.filter((person: any) => person.role.name == role);
  }

  _sortAndMergeCertificatedOutlets(funds:any[]){
    // Keep all funds and certificated outlets, then sort by name.
    return [...funds].sort((a:any, b:any) => a.name.localeCompare(b.name));
  }


  addFundDialog(){
    let sub:Subscription;
    let dialog = this.dialog.open(AddFundComponent, {minWidth:"30%", minHeight:"30%"});
    sub = dialog.afterClosed().subscribe(id => {
      //do redirect after close here
      sub?.unsubscribe();
    })
  }
  addOutletDialog(){
    let sub:Subscription;
    let dialog = this.dialog.open(AddCertificatedOutletComponent, {minWidth:"30%", minHeight:"30%"});
    sub = dialog.afterClosed().subscribe(id => {
      //do redirect after close here
      sub?.unsubscribe();
    })
  }

  goToPage(e:PageEvent){
    this.currentPage = e.pageIndex
    let start = this.currentPage * this.perPage
    let end = start + this.perPage
    this.dataSource.data = this.funds.slice(start, end)
    this.dataSource._updateChangeSubscription()
  }

  isSelectedPage(page:PageEvent){
    return this.currentPage == page.pageIndex
  }

  createPages(data:any[]){
    const numPages = data.length / this.perPage;
    this.pageLength = Math.max(1, Math.ceil(numPages));

    this.pages = Array.from({ length: this.pageLength }, (_, i) => ({
      pageIndex: i,            // zero-based for MatPaginator
      pageSize: this.perPage,
      length: data.length,
      previousPageIndex: undefined
    } as PageEvent));
  }

  protected readonly FundBtnType = FundBtnType;
}
